export default __webpack_public_path__ + "static/media/logo-dark.1d40399b.png";